<template>
    <div id="edit-report">
        <div class="content" v-if="detail">
            <a-dropdown :trigger="['click']">
                <a-menu slot="overlay"  @click="handleMenuClick">
                    <a-menu-item key="release">定稿</a-menu-item>
                    <a-menu-item key="share">分享</a-menu-item>
                    <a-menu-item key="download">下载</a-menu-item>
                    <a-menu-item key="delete">删除</a-menu-item>
                </a-menu>
                <a-button class="more-icon" style="margin-left: 8px">
                    <a-icon class="f20" type="ellipsis" />
                </a-button>
            </a-dropdown>
            <h1 class="header">{{detail.reportName}}</h1>
            <p class="user-info f16">
                <span>{{detail.name}}</span>
                <span>{{detail.timePoint}}</span>
                <span>{{detail.city}}</span>
            </p>
            <template v-if="detail.modules && detail.modules.length">
                <div 
                    v-for="(group,groupIndex) in detail.modules"
                    :key="groupIndex"
                >
                    <h2 class="f18">{{title[groupIndex]+"、"+group.moduleName}}</h2>
                    <template v-if="group.modules && group.modules.length">
                        <div
                            v-for="(secGroup,secGroupIndex) in group.modules"
                            :key="secGroupIndex"
                        >
                            <p class="f16" style="margin-left:20px;">{{secGroupIndex+1+"、"+secGroup.moduleName}}</p>
                            <template v-if="secGroup.modules && secGroup.modules.length">
                                <div
                                    v-for="(item,index) in secGroup.modules"
                                    :key="index"
                                    class="item-content"
                                >
                                    <a-popconfirm title="确认要删除此条解读吗？" @confirm="deleteItemSummaryItem(item.id)">
                                        <a-icon slot="icon" type="question-circle-o" style="color: #f5222d" />
                                        <a-icon title="删除" class="f16 icon delete-item" style="color: #f5222d" type="delete" /> 
                                    </a-popconfirm>
                                    <p class="description f16" style="text-indent:30px;" v-if="!index">{{item.description}}</p>
                                    <p class="description f16">
                                        图
                                        {{index+1}}
                                        是
                                        {{item.imageDate}}
                                        {{item.imageCity}}
                                        {{item.subModule}}
                                    </p>
                                    <template v-if="item.contents && item.contents.length">
                                        <p 
                                            v-for="child in item.contents"
                                            :key="child.id"
                                            class="description f16"
                                        >
                                            <span>{{child.content}}</span>
                                            <a-popconfirm title="确认要删除此条解读吗？" @confirm="deleteItemSummary(child.id)">
                                                <a-icon slot="icon" type="question-circle-o" style="color: #f5222d" />
                                                <a-icon title="删除" class="icon delete" type="delete" /> 
                                            </a-popconfirm>
                                            <a-icon title="编辑" @click="editItemContent(child.id,child.content)" class="icon edit" type="edit" />
                                        </p>
                                    </template>
                                    <img class="img" :src="item.imageUrl  | imgUrl(2)" />
                                    <p class="img-description">
                                        图
                                        {{index+1}}
                                        {{item.imageCity}}
                                        {{item.subModule}}
                                    </p>
                                </div>
                            </template>
                        </div>
                    </template>
                </div>
            </template>
            <div style="padding:20px 0">
                <h2>总结：</h2>
                <p class="description" v-if="detail.summary">
                    <span>{{detail.summary}}</span>
                    <a-popconfirm title="确认要删除总结吗？" @confirm="deleteSummary">
                        <a-icon slot="icon" type="question-circle-o" style="color: #f5222d" />
                        <a-icon class="icon delete" title="删除" type="delete" /> 
                    </a-popconfirm>
                    <a-icon class="icon edit" @click="editSummary(detail.summary)" title="编辑" type="edit" />
                </p>
                <template v-else>
                    <a-button @click="addSummary" style="margin-left:50px;">添加总结</a-button>
                    <p style="color:#D3D3D3;margin-left:50px">总结仅自己可见</p>
                </template>
            </div>
        </div>
        <a-modal 
            :title="editModalTitle" 
            v-model="showEditModal"
            :maskClosable="false"
            @ok="onEditModalOK"
            :okText="editModalTitle==='分享报告'?'复制链接':'确定'"
        >
            <a-textarea
                ref="textArea"
                :class="editModalTitle==='分享报告'?'disabled':''"
                :autosize="{ minRows: 3, maxRows: 6 }"
                v-model="editValue"
            />
        </a-modal>
    </div>
</template>

<script>
import UrlApi from "@/utils/UrlApi.js";
export default {
    name:"EditReport",
    data () {
        return {
            title:["一","二","三","四","五","六","七","八","九","十","十一","十二","十三","十四","十五","十六","十七","十八","十九","二十"],
            reportId: null,
            detail: null,
            editValue:null,
            showEditModal: false,
            editModalTitle:"修改总结",
            editContentId: null
        };
    },
    created(){
        if(!this.$route.query.id){
            this.$router.push("/report-list/answer");
            return;
        }
        this.reportId = this.$route.query.id;
        this.getReportDetail();
    },
    methods: {
        //  更多列表中选择
        handleMenuClick(val){
            if(val.key === "release"){
                this.releaseReport();
            }else if(val.key==="share"){
                this.shareReport("share");
            }else if(val.key==="download"){
                this.shareReport("download");
            }
        },
        // 分享解读报告
        shareReport(){
            let url = UrlApi.shareReport;
            let token = this.$store.getters.getToken;
            this.$http.get(url,{
                params:{
                    reportId: this.reportId
                },
                headers:{
                    "Authorization": token
                }
            }).then((res)=>{
                let {success,message} = res.data;
                if(success){
                    this.$message.success(message);
                    this.showShareModal(res.data.data)
                }else {
                    this.$message.warning(message);
                }
            })
        },
        showShareModal(url){
            this.showEditModal = true;
            this.editModalTitle = "分享报告";
            this.editValue = url;
        },
        // 定稿
        releaseReport(){
            let url = UrlApi.releaseReport+"?id="+this.detail.reportId;
            let token = this.$store.getters.getToken;
            this.$http.get(url,{
                headers:{
                    "Authorization": token
                }
            }).then((res)=>{
                let {success,message} = res.data;
                if(success){
                    this.$message.success(message);
                    this.$router.push({ name: 'ViewReport',query:{id:this.reportId}});
                }else {
                    this.$message.warning(message);
                }
            })
        },
        // 删除单条解读
        deleteItemSummary(id){
            let url = UrlApi.deleteReportContent;
            let token = this.$store.getters.getToken;
            let param = `ids=${id}`;
            this.$http.post(url,param,{
                headers:{
                    "Authorization": token,
                    "content-type": "application/x-www-form-urlencoded"
                }
            }).then((res)=>{
                let {success,message} = res.data;
                if(success){
                    this.getReportDetail();
                    this.$message.success(message);
                }else {
                    this.$message.warning(message);
                }
            })
        },
        // 删除单条解读 内的部分
        deleteItemSummaryItem(id){
            let url = UrlApi.deleteReportItem;
            let token = this.$store.getters.getToken;
            let param = `ids=${id}`;
            this.$http.post(url,param,{
                headers:{
                    "Authorization": token,
                    "content-type": "application/x-www-form-urlencoded"
                }
            }).then((res)=>{
                let {success,message} = res.data;
                if(success){
                    this.getReportDetail();
                    this.$message.success(message);
                }else {
                    this.$message.warning(message);
                }
            })
        },
        // 编辑单条解读
        editItemContent(id,val){
            this.showEditModal = true;
            this.editModalTitle = "修改解读信息";
            this.editValue = val;
            this.editContentId = id;
        },
        // 没有总结 添加总结
        addSummary(){
            this.showEditModal = true;
            this.editModalTitle = "添加总结";
        },
        // 删除总结
        deleteSummary(){
            this.detail.summary = "";
            this.modifyReport();
        },
        // 编辑总结
        editSummary(summary){
            this.editValue = summary;
            this.showEditModal = true;
            this.editModalTitle = "修改总结";
        },
        // 编辑窗口点击OK
        onEditModalOK(){
            if(this.editModalTitle === "修改总结" || this.editModalTitle === "添加总结"){
                this.detail.summary = String(this.editValue);
                this.editValue = null;
                this.modifyReport();
            }else if(this.editModalTitle === "分享报告") {
                this.$refs.textArea.$el.select();
                document.execCommand("Copy"); // 执行浏览器复制命令
                this.editValue = null;
                this.showEditModal = false;
                this.$message.success("复制链接成功");
            }else {
                this.modifyReportContent();
            }
        },
        // 获取报告详情
        getReportDetail(){
            let url = UrlApi.reportDetail;
            let token = this.$store.getters.getToken;
            this.$http.get(url,{
                params:{
                    reportId: this.reportId
                },
                headers:{
                    "Authorization": token
                }
            }).then((res)=>{
                if(res.data.data.releaseType){
                    this.$message.warning("此报告已定稿，无法再次编辑！");
                    this.$router.push("/report-list/answer")
                    return;
                }
                if(res.data.success){
                    this.detail = res.data.data;
                }else {
                    this.$message.warning(res.data.message);
                }
            })
        },
        // 修改报告中的content解读
        modifyReportContent(){
            let url = UrlApi.editReportContent;
            let token = this.$store.getters.getToken;
            let param = `id=${this.editContentId}&content=${this.editValue}`;
            this.$http.post(url,param,{
                headers:{
                    "Authorization": token
                }
            }).then((res)=>{
                let {success,message} = res.data;
                if(success){
                    this.getReportDetail();
                    this.$message.success(message);
                }else {
                    this.$message.warning(message);
                }
                this.showEditModal = false;
            })
        },
        // 修改报告总结
        modifyReport(){
            let url = UrlApi.modifyReport;
            let token = this.$store.getters.getToken;
            let param = `id=${this.reportId}&summary=${this.detail.summary}`;
            this.$http.post(url,param,{
                headers:{
                    "Authorization": token
                }
            }).then((res)=>{
                let {success,message} = res.data;
                if(success){
                    this.$message.success(message);
                }else {
                    this.$message.warning(message);
                }
                this.showEditModal = false;
            })
        }
    }
}

</script>
<style lang="less" scoped>
    .disabled {
        pointer-events: none;
        resize: none;
        color: rgba(0, 0, 0, 0.25);
        background-color: #f5f5f5;
    }
    #edit-report {
        width: 100%;
        margin: 0 auto;
        min-height: calc(100vh - 145px);
        height: auto;
        padding: 30px;
        .content {
            height: 100%;
            background-color: #ffffff;
            padding: 20px 150px 0 150px;
            height: auto;
            min-height: calc(100vh - 205px);
            position: relative;
            left: 0;
            top: 0;
            .item-content {
                box-sizing: border-box;
                border: 1px dotted #333333;
                padding: 20px 0;
                padding-right: 20px;
                position: relative;
                top: 0;
                left: 0;
                margin-bottom: 20px;
                .delete-item {
                    position: absolute;
                    right: 5px;
                    top: 5px;
                    cursor: pointer;
                }
            }
            .header {
                // text-align: center;
                margin-left: 30%;
            }
            .user-info {
                color:#9B9B9B;
                & > span {
                    margin-right: 10px;
                }
            }
            .description {
                margin-left: 60px;
                .icon {
                    margin-left: 20px;
                    cursor: pointer;
                    &.edit {
                        color:#1890ff;
                    }
                    &.delete {
                        color:#f5222d;
                    }
                }
            }
            .img {
                width: 600px;
                margin-left: 100px;
            }
            .img-description {
                margin: 20px 0 20px 250px;
            }
            .more-icon {
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
                position: fixed;
                top: calc(100vh - 400px);
                right: 140px;
            }
        }
    }
</style>